import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Grid,
	Typography
} from "@mui/material";
import col1 from "assets/loyalty-points/FTUE/col1-shop-v2.png";
import col2 from "assets/loyalty-points/FTUE/col2-redeem-v2.jpeg";
import col3 from "assets/loyalty-points/FTUE/col3-use-v2.jpeg";
import ThemeButton from "components/Buttons/ThemeButton";
import { useEnvContext, useGoogleAnalyticsContext } from "contexts";
import { FeaturesFlags } from "helpers";
import { useMegaMenuRedux } from "redux/slices/mega-menu/hooks/useMegaMenuRedux";
import CloseIconButton from "../lib/CloseIconButton";
import {
	buttonSxProps,
	dialogActionsSxProps,
	dialogContentSxProps,
	dialogContentTextSxProps,
	dialogSxProps,
	gridContainerSxProps,
	typographyMainHeadingSxProps
} from "./styled";

const DialogLoyaltyFaq = ({
	show,
	onCloseClick
}: {
	show: boolean;
	onCloseClick: () => void;
}) => {
	const { isFeatureFlagEnabled } = useEnvContext();
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const { cdnPrefix } = useEnvContext();
	const { toggleDrawer } = useMegaMenuRedux();
	return (
		<Dialog open={show} onClose={onCloseClick} sx={dialogSxProps}>
			<DialogTitle>
				<CloseIconButton
					onClose={() => {
						onCloseClick();
						reportEvent("dialog_x_closed", { source: "loyalty_faq_dialog" });
						reportPlaygamiEvent("tp.web_frontend", {
							event_name: "dialog_x_closed",
							event_type: "loyalty_faq_dialog",
							action: "dialog_x_closed",
							source: "loyalty_faq_dialog"
						});
					}}
				/>
			</DialogTitle>
			<DialogContent sx={dialogContentSxProps}>
				<DialogContentText sx={dialogContentTextSxProps}>
					<Typography
						variant="h5"
						component="strong"
						sx={typographyMainHeadingSxProps}
					>
						Earn Loyalty Points with every purchase!
					</Typography>
					<Grid container spacing={0} sx={gridContainerSxProps}>
						<Grid item>
							<img
								src={
									isFeatureFlagEnabled(FeaturesFlags.UI_V2)
										? col1
										: `${cdnPrefix}/spec_loyalty_faq/col1-shop.png`
								}
							/>
							<Typography className="title">Shop</Typography>
							<Typography className="desc" variant="caption" component="p">
								Purchase items in the Shop and collect Loyalty Points from your
								purchases.
							</Typography>
						</Grid>
						<Grid item>
							<img
								src={
									isFeatureFlagEnabled(FeaturesFlags.UI_V2)
										? col2
										: `${cdnPrefix}/spec_loyalty_faq/col2-redeem.png`
								}
							/>
							<Typography className="title">Redeem</Typography>
							<Typography className="desc" variant="caption" component="p">
								Use your Loyalty Points to redeem for exclusive rewards in
								Loyalty Shop.
							</Typography>
						</Grid>
						<Grid item>
							<img
								src={
									isFeatureFlagEnabled(FeaturesFlags.UI_V2)
										? col3
										: `${cdnPrefix}/spec_loyalty_faq/col3-use.png`
								}
							/>
							<Typography className="title">Use</Typography>
							<Typography className="desc" variant="caption" component="p">
								Return to your inbox in Tiki Solitaire TriPeaks and use your
								rewards in-game.
							</Typography>
						</Grid>
					</Grid>
				</DialogContentText>
			</DialogContent>
			<DialogActions sx={dialogActionsSxProps}>
				<ThemeButton
					onClick={() => {
						onCloseClick();
						toggleDrawer(false);
						reportEvent("continue_shopping_click", {
							source: "loyalty_faq_dialog"
						});
						reportPlaygamiEvent("tp.web_frontend", {
							event_name: "continue_shopping_click",
							event_type: "loyalty_faq_dialog",
							action: "continue_shopping_click",
							source: "loyalty_faq_dialog"
						});
					}}
					sx={buttonSxProps}
					themeColor="secondary"
				>
					Continue Shopping
				</ThemeButton>
			</DialogActions>
		</Dialog>
	);
};

export { DialogLoyaltyFaq };
